import script from "./ChatCreateDialogPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatCreateDialogPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatCreateDialogPanel.vue?vue&type=style&index=0&id=46436b4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46436b4a"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
